import type { TFunction } from "i18next";

export const PROMISE_PILLARS = ["arrival", "condition", "payment"] as const;
export type PromisePillar = (typeof PROMISE_PILLARS)[number];

export interface PromisePillarContent {
  id: PromisePillar;
  title: string;
  summary: string;
  detail: string;
}

export interface PromiseContent {
  title: string;
  widgetTitle: string;
  widgetBenefits: string[];
  fundsExplainer: string;
  eyebrow: string;
  intro: string;
  pillars: PromisePillarContent[];
  platformCondition: string;
  reportingRule: string;
  cancellationRule: string;
  contractualBoundary: string;
}

/**
 * The widget and full page deliberately consume this same model. Keep the
 * customer-facing commitments here rather than assembling parallel copy in
 * each surface.
 */
export function getPromiseContent(t: TFunction, brand: string): PromiseContent {
  const vars = { brand };
  return {
    title: t("promise.title", vars),
    widgetTitle: t("promise_widget.title", vars),
    widgetBenefits: [
      t("promise_widget.benefits.replacement_first", vars),
      t("promise_widget.benefits.refund", vars),
      t("promise_widget.benefits.support", vars),
      t("promise_widget.benefits.commitments", vars),
      t("promise_widget.benefits.secure_payment", vars),
    ],
    fundsExplainer: t("promise_widget.funds_explainer", vars),
    eyebrow: t("promise.eyebrow", vars),
    intro: t("promise.intro", vars),
    pillars: PROMISE_PILLARS.map((id) => ({
      id,
      title: t(`promise.pillars.${id}.title`, vars),
      summary: t(`promise.pillars.${id}.summary`, vars),
      detail: t(`promise.pillars.${id}.detail`, vars),
    })),
    platformCondition: t("promise.eligibility.platform", vars),
    reportingRule: t("promise.eligibility.reporting", vars),
    cancellationRule: t("promise.eligibility.cancellation", vars),
    contractualBoundary: t("promise.contractual_boundary", vars),
  };
}